import { NavLink } from 'react-router-dom';
import { Icon, SemanticICONS } from 'semantic-ui-react';

import { bem } from '../../../core/design/bem';
import { TabEntry } from '../tab.types';

const css = bem('Tab');

const TabItem = ({ _id, icon, label, to, exact }: TabEntry): JSX.Element => {
  return (
    <NavLink data-id={_id} className={css().toString()} to={to} exact={exact}>
      {icon && <Icon name={icon as SemanticICONS} />}
      <div className={css('Label')}>{label}</div>
    </NavLink>
  );
};

export default TabItem;
